(function () {
  // Theme-side client for back-to-store-module (see that folder's README for the backend this
  // talks to). Deliberately the only file this module needs inside assets/ — Shopify's asset
  // pipeline requires everything under assets/ to be flat (no subfolders reachable via
  // asset_url), so the module's own README, Apps Script source and tests live outside assets/
  // and this is the one thin file that bridges the two.
  //
  // Exposes window.CowalkiesBackInStock.notify(...) — called by assets/product-card.js and
  // assets/product-notify-me.js alongside their existing Shopify customer-tag submission (see
  // snippets/product-notify-me.liquid). Returns a Promise<boolean> (true = the Sheet actually
  // got the row) rather than being truly fire-and-forget — the two callers use it to decide
  // whether to show the notify form's success state at all (see their own comments on why:
  // Shopify's customer-form POST can get silently rejected by hCaptcha off localhost even for a
  // real shopper, while this request never touches hCaptcha — the resolved boolean is what lets
  // "the Sheet got it" count as success on its own instead of a misleading error appearing over
  // a request that actually worked). Never throws, never rejects — a merchant who hasn't
  // configured the endpoint yet (settings.back_in_stock_endpoint_url empty) gets a silent
  // `false`, not a console error.

  function isValidEmail(value) {
    return typeof value === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  }

  /**
   * @param {Object} params
   * @param {Element} params.wrap - the [data-notify-wrap] element (carries data-endpoint,
   *   data-product-id, data-product-title, data-option-names as JSON).
   * @param {string} params.email
   * @param {string|number|null} [params.variantId]
   * @param {Object<string,string>} [params.options] - { "Size": "M", "Color": "Sand" }
   * @returns {Promise<boolean>} resolves true only once the endpoint has actually accepted the
   *   row (HTTP ok) — never rejects.
   */
  function notify(params) {
    var wrap = params && params.wrap;
    if (!wrap) return Promise.resolve(false);

    var endpoint = wrap.getAttribute('data-endpoint');
    if (!endpoint || !isValidEmail(params.email)) return Promise.resolve(false);

    var payload = {
      email: params.email.trim(),
      productId: wrap.getAttribute('data-product-id') || '',
      productTitle: wrap.getAttribute('data-product-title') || '',
      productUrl: window.location.href,
      variantId: params.variantId != null ? String(params.variantId) : '',
      options: params.options || {},
    };

    // text/plain keeps this a CORS "simple request" (no OPTIONS preflight) — Apps Script Web
    // Apps don't handle preflight requests. The endpoint JSON.parses the raw body itself. See
    // back-to-store-module/README.md's "CORS gotcha" section before changing this.
    return fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.ok;
      })
      .catch(function (err) {
        console.warn('[back-in-stock] request failed', err);
        return false;
      });
  }

  window.CowalkiesBackInStock = { notify: notify };
})();
